import { IProgressGPTChatModel } from 'api/models';
import { DeleteConfirmationDrawer } from 'library/drawer';
import { FC } from 'react';
import { toast } from 'react-toastify';
import useDeleteProgressGPTChatForm from '../../hooks/useDeleteProgressGPTChatForm';

interface DeleteChatDrawerProps {
    show: boolean;
    onClose: () => void;
    chat: IProgressGPTChatModel;
    onDelete: (chatId: string) => void;
}

const DeleteChatDrawer: FC<DeleteChatDrawerProps> = (props) => {
    const { show, onClose, chat, onDelete } = props;

    const deleteChatForm = useDeleteProgressGPTChatForm({ chat });

    const handleDelete = async () => {
        try {
            await deleteChatForm.submit();

            toast.success('Chat deleted successfully.');

            onDelete(chat._id);

            onClose();
        } catch (err: any) {
            toast.error(err.data.message || 'Some error occured, please try again');
        }
    };

    return (
        <DeleteConfirmationDrawer
            className="shadow-[4px_0_20px_-4px_rgba(0,0,0,0.2)] dark:shadow-[4px_0_20px_-4px_rgba(0,0,0,0.3)]"
            show={show}
            onClose={onClose}
            title="Delete chat"
            message="Are you sure you want to delete this chat?"
            onConfirm={handleDelete}
            isConfirming={false}
        />
    );
};

export default DeleteChatDrawer;
